import ChatManager from "../../../../../core/gd-modules/chat-messages/manager/chat-manager";
import Chat from "../../../../../core/model2/chat/chat/chat";

export default class ChatController {

    public chatId      : ID
    public chatManager : ChatManager

    constructor(chatId: ID) {
        this.chatId      = chatId
        this.chatManager = new ChatManager(chatId, null)
    }

    leaveChat = (chatType: number) => {
        const proceedLeave = async () => {
            try{
                await gd.api.Chat.chatLeave(this.chatId);
                gd.navigate("/chat")


            }catch (e: any){
                console.log(e)
            }

        }

        const type = chatType === 3 ? "discussion" : "chat"

        gd.modals.confirm.genericText(`Leave ${type}`, `Are you sure you want to leave this ${type}?`, () => {
            gd.modal.hide();
            proceedLeave();
        }, {
            yesBtnLabel: 'Yes, leave'
        });
    }

    deleteChat = (chatType: number) => {
        const proceedDelete = async () => {
            try{
                await gd.api.Chat.chatDelete(this.chatId);
                gd.navigate("/chat")

            }catch (e: any){
                console.log(e)
            }

        }
        const type = chatType === 3 ? "discussion" : "chat"
        gd.modals.confirm.deleteTextMessage(`${type}`, `Are you sure you want to delete this ${type}?`,()=>{
            gd.modal.hide();
            proceedDelete();
        });
    }

    renameChat = (chat: Chat) => {
        gd.modals.oneInput('Chat name', chat.name, 'Rename', (newName:string)=>{
            gd.modal.hide();
            chat.name = newName;

            this.save(chat, newName)
            gd.bus.triggerEvent("chat-room:update-header", {id: chat.id, name: newName})
        })

    }

    save = (chat: Chat, name: any) => {
        gd.api.Chat.chatRename(chat.id, name);
        console.log("Rename")
        gd.bus.triggerEvent("chat-room:update", {
            id  : chat.id,
            name: name
        })
    }
}